/**
 * Arrival stop from the airline search result (`typeSpecific.details.destination`).
 * Airport-bus routes are fixed, so the stop is already known before the guest asks for a price.
 */
export const getAirlineAirportBusArrivalStop = (locationState: any): any | null => {
  if (locationState?.meta?.source !== "airline") {
    return null;
  }

  return locationState?.typeSpecific?.details?.destination || null;
};
